import { fetchUtils } from '../utils/fetch.utils';
import { getAPIUrl } from '../utils/config.utils';

const BASE_URL = getAPIUrl();

function getNotifications(params) {
  const query = fetchUtils.buildQuery(params);
  return fetchUtils.get(`${BASE_URL}/notifications?${query}`);
}

export const notificationRepository = {
    getNotifications,
};
